import { DEFAULT_PAGE_SIZE } from "../../constants/pagination";
import { SECTION } from "./actionTypes";

const INIT_STATE = {
  listaSection: {
    totalRecords: 0,
    records: [],
  },
  loadingSection: true,
  filterSection: null,
  section: null,
  messageSection: null,
  isSectionSave: null,
  sectionIdDuplicate: null,
  listaSectionHistory: [],
  loadingSectionHistory: true,
  errorLoadingSection: null,
  errorLoadingSectionHistory: null,
  errorSectionDuplicate: null,

  sectionProducts: null,
  loadingProducts: true,
  errorProducts: null,

  sectionSnippets: null,
  loadingSnippets: true,
  errorSnippets: null,

  sectionPreview: null,
  errorSectionPreview: null,

  pageSizeSection: DEFAULT_PAGE_SIZE,

  sectionList: null,
  errorSectionList: null,
};

const SectionReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SECTION.GET_LIST.REQUEST:
      return {
        ...state,
        filterSection: action.payload,
        loadingSection: true,
      };
    case SECTION.GET_LIST.SUCCESS:
      return {
        ...state,
        listaSection: action.payload,
        loadingSection: false,
      };
    case SECTION.GET_LIST.FAIL:
      return {
        ...state,
        messageSection: action.payload,
        loadingSection: false,
      };

    case SECTION.GET_SECTION.REQUEST:
      return {
        ...state,
        loadingSection: true,
      };
    case SECTION.GET_SECTION.SUCCESS:
      return {
        ...state,
        section: action.payload,
        loadingSection: false,
      };
    case SECTION.GET_SECTION.FAIL:
      return {
        ...state,
        messageSection: action.payload,
        loadingSection: false,
        errorLoadingSection: true,
      };

    case SECTION.SAVE_SECTION.REQUEST:
      return {
        ...state,
        loadingSection: true,
      };
    case SECTION.SAVE_SECTION.SUCCESS:
      return {
        ...state,
        isSectionSave: action.payload,
        loadingSection: false,
      };
    case SECTION.SAVE_SECTION.FAIL:
      return {
        ...state,
        loadingSection: false,
        isSectionSave: false,
        messageSection: action.payload,
      };

    case SECTION.LOAD_EMPTY:
      return {
        ...state,
        section: null,
        loadingSection: false,
        sectionPreview: null,
        errorLoadingSection: null,
        errorLoadingSectionHistory: null,
        errorSectionPreview: null,
      };

    case SECTION.CLEAN_MESSAGE:
      return {
        ...state,
        messageSection: null,
        loadingSection: false,
        isSectionSave: null,
        errorSectionPreview: null,
        sectionList: null,
        errorSectionList: null,
      };

    case SECTION.GET_SECTION_HISTORY.REQUEST:
      return {
        ...state,
        loadingSection: true,
      };
    case SECTION.GET_SECTION_HISTORY.SUCCESS:
      return {
        ...state,
        section: action.payload,
        loadingSection: false,
      };
    case SECTION.GET_SECTION_HISTORY.FAIL:
      return {
        ...state,
        loadingSection: false,
        messageSection: action.payload,
        errorLoadingSectionHistory: false,
      };

    case SECTION.GET_SECTION_HISTORY_LIST.REQUEST:
      return {
        ...state,
        loadingSectionHistory: true,
      };
    case SECTION.GET_SECTION_HISTORY_LIST.SUCCESS:
      return {
        ...state,
        listaSectionHistory: action.payload,
        loadingSectionHistory: false,
      };
    case SECTION.GET_SECTION_HISTORY_LIST.FAIL:
      return {
        ...state,
        errorLoadingSectionHistory: true,
        loadingSectionHistory: false,
      };
    
    case SECTION.DUPLICATE_SECTION.REQUEST:
      return {
        ...state,
        loadingSection: true,
      };
    case SECTION.DUPLICATE_SECTION.SUCCESS:
      return {
        ...state,
        sectionIdDuplicate: action.payload,
        loadingSection: false,
      };
    case SECTION.DUPLICATE_SECTION.FAIL:
      return {
        ...state,
        loadingSection: false,
        sectionIdDuplicate: false,
        errorSectionDuplicate: action.payload,
      };

    case SECTION.GET_SECTION_PRODUCTS.REQUEST:
      return {
        ...state,
        loadingProducts: true,
      };
    case SECTION.GET_SECTION_PRODUCTS.SUCCESS:
      return {
        ...state,
        sectionProducts: action.payload,
        loadingProducts: false,
      };
    case SECTION.GET_SECTION_PRODUCTS.FAIL:
      return {
        ...state,
        loadingProducts: false,
        errorProducts: action.payload,
      };

    case SECTION.GET_SECTION_SNIPPETS.REQUEST:
      return {
        ...state,
        loadingSnippets: true,
      };
    case SECTION.GET_SECTION_SNIPPETS.SUCCESS:
      return {
        ...state,
        sectionSnippets: action.payload,
        loadingSnippets: false,
      };
    case SECTION.GET_SECTION_SNIPPETS.FAIL:
      return {
        ...state,
        loadingSnippets: false,
        errorSnippets: action.payload,
      };

    case SECTION.GET_SECTION_PREVIEW.REQUEST:
      return {
        ...state,
        loadingSection: true,
        errorSectionPreview: null,
        sectionPreview: null,
      };
    case SECTION.GET_SECTION_PREVIEW.SUCCESS:
      return {
        ...state,
        sectionPreview: action.payload,
        loadingSection: false,
      };
    case SECTION.GET_SECTION_PREVIEW.FAIL:
      return {
        ...state,
        loadingSection: false,
        sectionPreview: false,
        errorSectionPreview: action.payload,
      };

    case SECTION.DISABLE_LOADING_SECTION:
      return {
        ...state,
        loadingSectionHistory: false,
        loadingSection: false,
      };
    case SECTION.CLEAN_ID_SECTION_DUPLICATE:
      return {
        ...state,
        sectionIdDuplicate: null,
        loadingSection: false,
      };
    case SECTION.CHANGE_PAGE_SIZE_SECTION:
      return {
        ...state,
        pageSizeSection: action.payload,
      };

    case SECTION.POST_SECTION_DOWNLOAD_LIST.REQUEST:
      return {
        ...state,
        loadingSection: true,
      };
    case SECTION.POST_SECTION_DOWNLOAD_LIST.SUCCESS:
      return {
        ...state,
        sectionList: action.payload,
        loadingSection: false,
      };
    case SECTION.POST_SECTION_DOWNLOAD_LIST.FAIL:
      return {
        ...state,
        loadingSection: false,
        errorSectionList: action.payload,
      };

    default:
      return state;
  }
};

export default SectionReducer;
